import { Link } from 'react-router-dom'

export default function Menu() {
    return (    
        <nav className="font-sans hidden sm:flex sm:text-sm xl:text-base font-light uppercase text-white sm:space-x-6 xl:space-x-12">
            <Link to="about-us" className="hover:text-yellow-400 transition">About Us</Link>
            <Link to="our-games" className="hover:text-yellow-400 transition">Our Games</Link>
            <Link to="contact-us" className="hover:text-yellow-400 transition">Contact Us</Link>
            <Link to="news" className="hover:text-yellow-400 transition">News</Link>
        </nav>
    )
}